import { Box, Caption } from "@bcc-ui/ui-components";
import React from "react";

interface Props {
    children: React.ReactNode;
    caption?: boolean;
}

export const NavigationLabel = (props: Props) => {
    if (props.caption) {
        return (
            <Box columnLayout paddingTop="Xxs" paddingBottom="Xxs" paddingLeft="Xs" paddingRight="Xs">
                <Caption greyTextStyle>{props.children}</Caption>
            </Box>
        );
    }

    return (
        <Box columnLayout paddingTop="Xxs" paddingBottom="Xxs" paddingLeft="Xs" paddingRight="Xs">
            {props.children}
        </Box>
    );
};
